import { Body, FramedIcon, Icon, Stack } from "@biom3/react";
import { Fragment, type ReactNode } from "react";

export type LeaderboardItemStyle = "large" | "currentUser" | "default";
export type LeaderboardItemProps = {
  position: number;
  name: string | ReactNode;
  score: number;
  style: LeaderboardItemStyle;
};

export const LeaderboardItem = ({
  position,
  name,
  score,
  style,
}: LeaderboardItemProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        borderRadius: "base.borderRadius.x4",
        background:
          style === "currentUser"
            ? "linear-gradient(to right, #F191FA32, #83E3F032)"
            : style === "large"
              ? "base.color.translucent.emphasis.100"
              : undefined,
        padding: "base.spacing.x3",
      }}
    >
      <Body
        sx={{
          fontFamily: "base.font.family.body.secondary",
          marginRight: "base.spacing.x4",
        }}
      >
        {position.toString().padStart(3, "0")}
      </Body>
      <FramedIcon
        icon="Profile"
        variant="bold"
        emphasized
        circularFrame
        sx={{
          background: style === "currentUser" ? "base.gradient.1" : undefined,
          width: style === "default" ? "32px" : "48px",
          height: style === "default" ? "32px" : "48px",
          fill: style === "currentUser" ? "black" : undefined,
        }}
      />
      <Stack gap="0" sx={{ flex: 1, marginLeft: "base.spacing.x4" }}>
        <Body
          size="xSmall"
          sx={{
            fontFamily: "base.font.family.body.secondary",
          }}
        >
          {name}
        </Body>
        {style === "currentUser" && (
          <Body
            size="xSmall"
            sx={{
              fontFamily: "base.font.family.body.secondary",
              color: "base.color.text.body.secondary",
            }}
          >
            You
          </Body>
        )}
      </Stack>
      <Fragment>
        <Body
          size="xSmall"
          sx={{
            fontFamily: "base.font.family.body.secondary",
          }}
        >
          {score}
        </Body>
        <Icon variant="bold" icon="Sparkle" />
      </Fragment>
    </Stack>
  );
};
